module.exports = __webpack_public_path__ + "img/stock5.ab37135a.png";